<template>
  <div class="archive-payments">
    <div class="archive-payments__groups">
      <div
        class="archive__group"
        v-for="order in orders"
        :key="`order-${order.id}`"
      >
        <div class="archive__client-info">
          <div class="archive__client-info-title">
            {{ $t("archive.client_info.title") }}
          </div>
          <div class="archive__client-info-item">
            <div class="archive__client-info-item-title">
              {{ $t("archive.client_info.full_name") }}
            </div>
            <div class="archive__client-info-item-value">
              {{ order.client.full_name }}
            </div>
          </div>
          <div class="archive__client-info-item">
            <div class="archive__client-info-item-title">
              {{ $t("cart.client_info.inn") }}
            </div>
            <div class="archive__client-info-item-value">
              {{ order.client.inn }}
            </div>
          </div>
          <div
            class="archive__update-status"
            @click="updateOrderStatus(order.id)"
          >
            {{ $t("archive.status.update") }}
          </div>
        </div>
        <table class="archive__table">
          <span class="archive__table-border"></span>
          <thead>
            <tr>
              <td>{{ $t("archive.table.created") }}</td>
              <td>{{ $t("archive.table.payer") }}</td>
              <td>{{ $t("archive.table.payment_type") }}</td>
              <td>{{ $t("archive.table.amount") }}</td>
              <td>{{ $t("archive.table.status") }}</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              class="archive__item"
              v-for="orderItem in order.items"
              :key="`order-item-${orderItem.id}`"
            >
              <td>
                <div class="archive__item-created">
                  <div class="archive__item-created-date">
                    {{ $moment(orderItem.created_at).format("DD.MM.YY") }}
                  </div>
                  <div class="archive__item-created-time">
                    {{ $moment(orderItem.created_at).format("hh:mm:ss") }}
                  </div>
                </div>
              </td>
              <td>
                <div class="archive__item-recipient">
                  {{ order.client.full_name }}
                </div>
              </td>
              <td>
                <div class="archive__item-payment_type">
                  {{ $t(orderItem.payment_type.slug) }}
                </div>
              </td>
              <td>
                <div class="archive__item-amount">{{ orderItem.sum_full }}</div>
              </td>
              <td style="z-index: 4">
                <div class="archive__item-amount">
                  <div class="archive__item-amount-text">
                    {{ $t(getOrderStatus(order)) }}
                  </div>
                  <div
                    class="archive__item-receipt"
                    v-if="
                      order.status === orderStatuses.paid ||
                      order.can_refund === true
                    "
                  >
                    <div
                      class="archive__item-receipt-print-options"
                      v-if="orderItemReceiptsActive === orderItem.id"
                      v-click-outside="hideReceiptOptions"
                    >
                      <div
                        class="archive__item-receipt-print-option"
                        :class="{
                          disabled: isReceiptLoading(orderItem.id, 'payment'),
                        }"
                        @click="downloadReceipt(orderItem.id, 'payment')"
                      >
                        {{
                          isReceiptLoading(orderItem.id, "payment")
                            ? $t("loading")
                            : $t("archive.cart_item.receipt.payment")
                        }}
                      </div>
                      <div
                        class="archive__item-receipt-print-option"
                        :class="{
                          disabled: isReceiptLoading(
                            orderItem.id,
                            'commission'
                          ),
                        }"
                        @click="downloadReceipt(orderItem.id, 'commission')"
                      >
                        {{
                          isReceiptLoading(orderItem.id, "commission")
                            ? $t("loading")
                            : $t("archive.cart_item.receipt.commission")
                        }}
                      </div>
                    </div>
                    <div
                      class="archive__item-receipt-print"
                      @click="showReceiptOptions(orderItem.id)"
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.2168 4.78711H15.6973V2.7832C15.6973 1.24854 14.4487 0 12.9141 0H6.08594C4.55128 0 3.30273 1.24854 3.30273 2.7832V4.78711H2.7832C1.24854 4.78711 0 6.03565 0 7.57031V12.0234C0 13.5581 1.24854 14.8066 2.7832 14.8066H3.30273V17.3301C3.30273 18.2509 4.05186 19 4.97266 19H14.0273C14.9481 19 15.6973 18.2509 15.6973 17.3301V14.8066H16.2168C17.7515 14.8066 19 13.5581 19 12.0234V7.57031C19 6.03565 17.7515 4.78711 16.2168 4.78711ZM4.41602 2.7832C4.41602 1.86241 5.16514 1.11328 6.08594 1.11328H12.9141C13.8349 1.11328 14.584 1.86241 14.584 2.7832V4.78711H4.41602V2.7832ZM14.584 17.3301C14.584 17.637 14.3343 17.8867 14.0273 17.8867H4.97266C4.66572 17.8867 4.41602 17.637 4.41602 17.3301V11.8379H14.584V17.3301ZM17.8867 12.0234C17.8867 12.9442 17.1376 13.6934 16.2168 13.6934H15.6973V11.8379H16.0312C16.3387 11.8379 16.5879 11.5887 16.5879 11.2812C16.5879 10.9738 16.3387 10.7246 16.0312 10.7246H2.96875C2.66134 10.7246 2.41211 10.9738 2.41211 11.2812C2.41211 11.5887 2.66134 11.8379 2.96875 11.8379H3.30273V13.6934H2.7832C1.86241 13.6934 1.11328 12.9442 1.11328 12.0234V7.57031C1.11328 6.64952 1.86241 5.90039 2.7832 5.90039H16.2168C17.1376 5.90039 17.8867 6.64952 17.8867 7.57031V12.0234Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M10.9844 13.0996H8.01562C7.70821 13.0996 7.45898 13.3488 7.45898 13.6562C7.45898 13.9637 7.70821 14.2129 8.01562 14.2129H10.9844C11.2918 14.2129 11.541 13.9637 11.541 13.6562C11.541 13.3488 11.2918 13.0996 10.9844 13.0996Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M10.9844 15.4746H8.01562C7.70821 15.4746 7.45898 15.7238 7.45898 16.0312C7.45898 16.3387 7.70821 16.5879 8.01562 16.5879H10.9844C11.2918 16.5879 11.541 16.3387 11.541 16.0312C11.541 15.7238 11.2918 15.4746 10.9844 15.4746Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M4.75 7.16211H2.96875C2.66134 7.16211 2.41211 7.41134 2.41211 7.71875C2.41211 8.02616 2.66134 8.27539 2.96875 8.27539H4.75C5.05741 8.27539 5.30664 8.02616 5.30664 7.71875C5.30664 7.41134 5.05741 7.16211 4.75 7.16211Z"
                          fill="#5C91F2"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    class="archive__item-pay-link"
                    v-if="
                      order.status === orderStatuses.pending ||
                      (order.widget_type === 'pos' && order.can_refund)
                    "
                    @click="toPayUrl(order.widget_url, order.widget_type)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      data-name="Layer 1"
                      viewBox="0 0 24 24"
                      id="qr-code-scan"
                      v-if="order.widget_type === 'qr'"
                    >
                      <path
                        d="M8 21H4a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h4a1 1 0 0 0 0-2Zm14-6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 0 0 2h4a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1ZM20 1h-4a1 1 0 0 0 0 2h4a1 1 0 0 1 1 1v4a1 1 0 0 0 2 0V4a3 3 0 0 0-3-3ZM2 9a1 1 0 0 0 1-1V4a1 1 0 0 1 1-1h4a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v4a1 1 0 0 0 1 1Zm8-4H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1ZM9 9H7V7h2Zm5 2h4a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1Zm1-4h2v2h-2Zm-5 6H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-1 4H7v-2h2Zm5-1a1 1 0 0 0 1-1 1 1 0 0 0 0-2h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm4-3a1 1 0 0 0-1 1v3a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-4 4a1 1 0 1 0 1 1 1 1 0 0 0-1-1Z"
                      />
                    </svg>
                    <svg
                      v-if="order.widget_type === 'pos'"
                      xmlns="http://www.w3.org/2000/svg"
                      data-name="Layer 1"
                      viewBox="0 0 128 160"
                      x="0px"
                      y="0px"
                    >
                      <path
                        d="M90,69.35294v16a2,2,0,1,0,4,0v-16a2,2,0,0,0-4,0Z"
                      />
                      <path
                        d="M87,63.60294a6.00516,6.00516,0,0,0,5.126-9.125,6,6,0,1,0-10.252,0A6.00516,6.00516,0,0,0,87,63.60294Zm-1.24707-10.6875A1.98049,1.98049,0,0,1,85,51.35294a2,2,0,0,1,4,0,1.98049,1.98049,0,0,1-.75293,1.5625,2.00072,2.00072,0,0,0,.01074,3.14258A1.944,1.944,0,0,1,89,57.60294a2,2,0,1,1-4,0,1.944,1.944,0,0,1,.74219-1.54492,2.00072,2.00072,0,0,0,.01074-3.14258Z"
                      />
                      <path
                        d="M81,41.35294h22v66H81v4h30a6.00656,6.00656,0,0,0,6-6v-62a6.00656,6.00656,0,0,0-6-6H81Zm32,2v62a2.00261,2.00261,0,0,1-2,2h-4v-66h4A2.00261,2.00261,0,0,1,113,43.35294Z"
                      />
                      <path
                        d="M81,91.78849a2,2,0,1,0,4,0V69.35294a2,2,0,0,0-4,0Z"
                      />
                      <path
                        d="M17,128.35294H71a6.00656,6.00656,0,0,0,6-6v-96a6.00656,6.00656,0,0,0-6-6H67v4h4a2.00261,2.00261,0,0,1,2,2v96a2.00261,2.00261,0,0,1-2,2H17a2.00261,2.00261,0,0,1-2-2v-96a2.00261,2.00261,0,0,1,2-2h4v-4H17a6.00656,6.00656,0,0,0-6,6v96A6.00656,6.00656,0,0,0,17,128.35294Z"
                      />
                      <path
                        d="M20,40.35294a2.0001,2.0001,0,0,0,2,2H66a2,2,0,0,0,0-4H63v-35a1.98087,1.98087,0,0,0-.07166-.503A1.99229,1.99229,0,0,0,59.84766.71818L55.3291,3.90568,50.81055.71818a2.00093,2.00093,0,0,0-2.30566.001L43.99219,3.9047,39.4834.71915a2.00074,2.00074,0,0,0-2.30762,0L32.66406,3.9047,28.15332.71915A1.99177,1.99177,0,0,0,25.072,2.84891a1.98326,1.98326,0,0,0-.072.504v35H22A2.0001,2.0001,0,0,0,20,40.35294ZM29,6.2136l2.51074,1.77313a1.9992,1.9992,0,0,0,2.30664,0L38.3291,4.80118l4.50781,3.18555a1.99911,1.99911,0,0,0,2.30762,0L49.6582,4.80021l4.51855,3.1875a2.00049,2.00049,0,0,0,2.30469,0L59,6.21122V38.35294H29Z"
                      />
                      <path
                        d="M67,60.35294v-8a4.004,4.004,0,0,0-4-4H25a4.004,4.004,0,0,0-4,4v8a4.004,4.004,0,0,0,4,4H63A4.004,4.004,0,0,0,67,60.35294Zm-42-8H63l.00293,8H25Z"
                      />
                      <path
                        d="M32,72.35294a2.0001,2.0001,0,0,0-2-2H22a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H24v-4h4Z"
                      />
                      <path
                        d="M50,72.35294a2.0001,2.0001,0,0,0-2-2H40a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H42v-4h4Z"
                      />
                      <path
                        d="M68,72.35294a2.0001,2.0001,0,0,0-2-2H58a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H60v-4h4Z"
                      />
                      <path
                        d="M68,90.35294a2.0001,2.0001,0,0,0-2-2H58a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H60v-4h4Z"
                      />
                      <path
                        d="M50,90.35294a2.0001,2.0001,0,0,0-2-2H40a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H42v-4h4Z"
                      />
                      <path
                        d="M32,90.35294a2.0001,2.0001,0,0,0-2-2H22a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2Zm-4,6H24v-4h4Z"
                      />
                      <path
                        d="M30,106.35294H22a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2v-8A2.0001,2.0001,0,0,0,30,106.35294Zm-2,8H24v-4h4Z"
                      />
                      <path
                        d="M48,106.35294H40a2.0001,2.0001,0,0,0-2,2v8a2.0001,2.0001,0,0,0,2,2h8a2.0001,2.0001,0,0,0,2-2v-8A2.0001,2.0001,0,0,0,48,106.35294Zm-2,8H42v-4h4Z"
                      />
                      <path
                        d="M58,118.35294h8a2.0001,2.0001,0,0,0,2-2v-8a2.0001,2.0001,0,0,0-2-2H58a2.0001,2.0001,0,0,0-2,2v8A2.0001,2.0001,0,0,0,58,118.35294Zm2-8h4v4H60Z"
                      />
                    </svg>
                  </div>
                </div>
              </td>
              <td>
                <div class="archive__item-actions">
                  <div
                    @click="repeatPayment(orderItem.id)"
                    class="archive__item-action archive__item-action--repeat"
                  >
                    <div class="archive__item-action-icon">
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 9C13 12.3137 10.3137 15 7 15C3.68629 15 1 12.3137 1 9C1 5.68629 3.68629 3 7 3"
                          stroke="#5C91F2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M6.5 5.5L7.68615 3.04253C7.95137 2.49304 7.66694 1.83618 7.08473 1.65365L5.00012 1.00006"
                          stroke="#5C91F2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <div class="archive__item-action-text">
                      {{ $t("archive.table.action.repeat") }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="archive__total">
          <div class="archive__total-title">
            {{ $t("archive.total.section_title") }}
          </div>
          <div class="archive__total-amount">
            <div class="archive__total-amount-title">
              {{
                $t("archive.total.title", { itemsCount: order.items.length })
              }}
            </div>
            <div class="archive__total-amount-value">
              {{ roundOrderSum(order.sum) }} {{ $t("currency") }}
            </div>
          </div>
          <div
            class="archive__receipt"
            v-if="order.status === orderStatuses.paid"
          >
            <div
              class="archive__receipt-print-options"
              v-if="orderItemReceiptsActive === `order-${order.id}`"
              v-click-outside="hideReceiptOptions"
            >
              <div
                class="archive__receipt-print-option"
                :class="{
                  disabled: isReceiptLoading(`order-${order.id}`, 'payment'),
                }"
                @click="downloadOrderReceipt(order.id, 'payment')"
              >
                {{
                  isReceiptLoading(`order-${order.id}`, "payment")
                    ? $t("loading")
                    : $t("archive.cart_item.receipt.payment")
                }}
              </div>
              <div
                class="archive__receipt-print-option"
                :class="{
                  disabled: isReceiptLoading(`order-${order.id}`, 'commission'),
                }"
                @click="downloadOrderReceipt(order.id, 'commission')"
              >
                {{
                  isReceiptLoading(`order-${order.id}`, "commission")
                    ? $t("loading")
                    : $t("archive.cart_item.receipt.commission")
                }}
              </div>
            </div>
            <div
              class="archive__receipt-print"
              @click="showReceiptOptions(`order-${order.id}`)"
            >
              <div class="archive__receipt-print-text">
                {{ $t("archive.cart_item.receipt.download") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="archive-payments__actions">
      <primary-button
        :text="$t('archive.action.create_payment')"
        @click="toCreatePayment"
      ></primary-button>
    </div>
    <pay-order-qr-popup ref="payOrderQRPopup"></pay-order-qr-popup>
  </div>
</template>

<script>
import { OrderApi } from "@/office/order/order-api";
import FileSaver from "file-saver";
import PrimaryButton from "@/components/buttons/PrimaryButton";
import { STATUS_PAID, STATUS_PENDING } from "@/const/order/order-statuses";
import PayOrderQrPopup from "@/components/order/PayOrderQrPopup";

export default {
  name: "ArchivePayments",
  components: { PayOrderQrPopup, PrimaryButton },
  data() {
    return {
      orders: [],
      orderStatuses: {
        paid: STATUS_PAID,
        pending: STATUS_PENDING,
      },
      orderItemReceiptsActive: null,
      orderItemReceiptsLoading: [],
    };
  },
  created() {
    this.loadOrders();
  },
  methods: {
    getOrderStatus(order) {
      console.log(order);
      if (order.widget_type !== "pos") {
        return order.status;
      }

      if (
        (order.status === "pending" || order.status === "paid") &&
        order.can_refund
      ) {
        return "paid";
      }

      if (order.status === "paid" && !order.can_refund) {
        return "approved";
      }

      return order.status;
    },
    loadOrders() {
      new OrderApi().getOrders().then((r) => {
        this.orders = r.data.orders;
      });
    },
    downloadReceipt(orderItemId, receiptType) {
      if (this.isReceiptLoading(orderItemId, receiptType)) {
        return;
      }

      this.orderItemReceiptsActive = null;

      this.orderItemReceiptsLoading.push({ id: orderItemId, receiptType });
      new OrderApi()
        .loadReceipt(orderItemId, receiptType)
        .then((r) => {
          FileSaver.saveAs(r.data, `Receipt-payment-${orderItemId}.pdf`);
        })
        .finally(() => {
          let _index = this.orderItemReceiptsLoading.findIndex(
            (_item) =>
              _item.id === orderItemId && _item.receiptType === receiptType
          );

          this.orderItemReceiptsLoading.splice(_index, 1);
        });
    },
    downloadOrderReceipt(orderId, receiptType) {
      if (this.isReceiptLoading(`order-${orderId}`, receiptType)) {
        return;
      }

      this.orderItemReceiptsActive = null;

      this.orderItemReceiptsLoading.push({
        id: `order-${orderId}`,
        receiptType,
      });
      new OrderApi()
        .loadOrderPDFReceipt(orderId, receiptType)
        .then((r) => {
          FileSaver.saveAs(r.data, `Receipt-${orderId}-${receiptType}.pdf`);
        })
        .finally(() => {
          let _index = this.orderItemReceiptsLoading.findIndex(
            (_item) =>
              _item.id === `order-${orderId}` &&
              _item.receiptType === receiptType
          );

          this.orderItemReceiptsLoading.splice(_index, 1);
        });
    },
    isReceiptLoading(orderItemId, receiptType) {
      return (
        this.orderItemReceiptsLoading.findIndex(
          (_item) =>
            _item.id === orderItemId && _item.receiptType === receiptType
        ) > -1
      );
    },
    updateOrderStatus(orderId) {
      new OrderApi().getOrderStatus(orderId).then((r) => {
        let orderIndex = this.orders.findIndex((o) => o.id === orderId);

        this.orders[orderIndex] = {
          ...this.orders[orderIndex],
          can_refund: r.data.can_refund,
          status: r.data.status,
        };

        this.orders = [...this.orders];
      });
    },
    toCreatePayment() {
      this.$router.push("/");
    },
    toPayUrl(widgetUrl, widgetType) {
      if (widgetType === "pos") {
        window.open(widgetUrl, "_blank");
      } else {
        this.$refs.payOrderQRPopup.open(widgetUrl);
      }
    },
    showReceiptOptions(orderItemId) {
      this.orderItemReceiptsActive = orderItemId;
    },
    hideReceiptOptions() {
      this.orderItemReceiptsActive = null;
    },
    repeatPayment(orderItemId) {
      this.$router.push({
        path: "/",
        query: {
          repeat_item_id: orderItemId,
        },
      });
    },
    roundOrderSum(sum) {
      return Math.round((sum + Number.EPSILON) * 100) / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.archive {
  &__group {
    margin-bottom: 30px;
  }

  &__update {
    &-status {
      font-weight: bold;
      color: $action;
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      margin-left: auto;
      cursor: pointer;
      transition: opacity 0.2s linear;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__client-info {
    padding: 23px 32px;
    display: flex;
    align-items: center;
    border: 1px solid #f0f3fa;
    border-bottom: unset;
    border-radius: 16px 16px 0 0;

    &-title {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      margin-right: 25px;
    }

    &-item {
      display: flex;
      align-items: center;
      margin-right: 40px;

      &:last-child {
        margin-right: 0;
      }

      &-title {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $text;
        margin-right: 5px;
      }

      &-value {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $action;
      }
    }
  }

  &__table {
    width: 100%;
    position: relative;
    border-collapse: collapse;

    &-border {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 1px solid #f0f3fa;
      border-radius: 0;
      top: 0;
      left: 0;
      z-index: 0;
    }

    td {
      padding: 24px 32px;
      position: relative;
      z-index: 2;
    }

    thead {
      tr {
        background-color: #fafcfe;
        border-bottom: 1px solid #f0f3fa;

        td {
          color: $textLight;
          font-weight: 500;
          font-size: pxToRem(10);
          line-height: pxToRem(12);

          &:first-child {
            border-radius: 16px 0 0 0;
          }

          &:last-child {
            border-radius: 0 16px 0 0;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f0f3fa;

        &:last-child {
          border-bottom: none;

          td {
            &:first-child {
              border-radius: 0 0 0 16px;
            }

            &:last-child {
              border-radius: 0 0 16px 0;
            }
          }
        }
      }
    }
  }

  &__item {
    &-created {
      &-date {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        margin-bottom: 1px;
      }

      &-time {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        opacity: 0.6;
      }
    }

    &-recipient {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-payment_type {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-amount {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
      display: flex;
      align-items: center;
    }

    &-receipt {
      z-index: 9;
      position: relative;
      &-print {
        z-index: 1;
        position: relative;
        cursor: pointer;
        margin-left: 25px;
        width: 19px;
        height: 19px;

        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s linear;

        &:hover {
          opacity: 0.8;
        }

        svg {
          width: 100%;
          height: 100%;
        }

        &-options {
          position: absolute;
          background: #ffffff;
          border: 1px solid #f0f3fa;
          box-shadow: 0px 4px 10px rgba(232, 239, 253, 0.5);
          border-radius: 7px;
          padding: 10px 15px;
          z-index: 9;
          bottom: calc(100% + 10px);
          transform: translateX(-50%);
          left: 50%;
        }

        &-option {
          margin-bottom: 10px;
          transition: opacity 0.2s linear;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    &-pay {
      &-link {
        cursor: pointer;
        margin-left: 25px;
        width: 25px;
        height: 25px;

        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s linear;

        &:hover {
          opacity: 0.8;
        }

        svg {
          width: 100%;
          height: 100%;
          object-fit: cover;

          path,
          rect,
          circle {
            fill: $action;
          }
        }
      }
    }

    &-actions {
      display: flex;
      align-items: center;
    }

    &-action {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      cursor: pointer;
      transition: opacity 0.2s linear;

      &--repeat & {
        &-text {
          color: $action;
        }
      }

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }

      &-text {
        font-weight: bold;
        font-size: pxToRem(12);
        line-height: pxToRem(18);
        color: $text;
      }

      &:hover {
        opacity: 0.8;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__total {
    display: flex;
    align-items: center;
    padding: 32px;
    border: 1px solid #f0f3fa;
    border-top: unset;
    border-radius: 0 0 16px 16px;

    &-title {
      margin-right: 84px;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      color: $textLight;
    }

    &-amount {
      display: flex;
      align-items: center;

      &-title {
        margin-right: 20px;
        font-size: pxToRem(12);
        line-height: pxToRem(18);
        color: $text;
      }

      &-value {
        font-weight: 600;
        font-size: pxToRem(16);
        line-height: pxToRem(20);
        color: $green;
      }
    }
  }

  &__receipt {
    z-index: 9;
    position: relative;
    margin-left: auto;
    margin-right: auto;

    &-print {
      z-index: 1;
      position: relative;
      cursor: pointer;
      //margin-left: 25px;
      //width: 19px;
      //height: 19px;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.2s linear;

      &-text {
        color: $action;
        font-size: pxToRem(16);
        line-height: pxToRem(20);
        font-weight: bold;
      }

      &:hover {
        opacity: 0.8;
      }

      svg {
        width: 100%;
        height: 100%;
      }

      &-options {
        position: absolute;
        background: #ffffff;
        border: 1px solid #f0f3fa;
        box-shadow: 0px 4px 10px rgba(232, 239, 253, 0.5);
        border-radius: 7px;
        padding: 10px 15px;
        z-index: 9;
        bottom: calc(100% + 10px);
        transform: translateX(-50%);
        left: 50%;
      }

      &-option {
        margin-bottom: 10px;
        transition: opacity 0.2s linear;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  &-payments {
    position: relative;

    &__groups {
      &:empty {
        border-top: 1px solid #f0f3fa;
      }
    }

    &__actions {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
